function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "h_flip/24"
}, React.createElement("path", {
  d: "M19.865559,10.4933814 C19.6875402,10.805044 19.3561479,10.9973982 18.9972269,10.9973982 L5.99852805,10.9973982 C4.89395855,10.9973982 3.99852805,10.1019677 3.99852805,8.99739818 L3.99852805,2.00147195 C3.99852805,1.4491872 4.4462433,1.00147195 4.99852805,1.00147195 C5.17249419,1.00147195 5.34345088,1.04685555 5.49451126,1.13313983 L19.4932101,9.12906606 C19.9727767,9.40299002 20.139483,10.0138148 19.865559,10.4933814 Z M19.865559,13.5054887 C20.119917,13.9508006 19.9943438,14.5092891 19.5911391,14.80612 L19.4932101,14.8698041 L5.49451126,22.8657303 C5.34345088,22.9520146 5.17249419,22.9973982 4.99852805,22.9973982 C4.48569221,22.9973982 4.06302089,22.611358 4.00525578,22.1140193 L3.99852805,21.9973982 L3.99852805,15.0014719 C3.99852805,13.9471102 4.81440584,13.0833068 5.84926571,13.0069577 L5.99852805,13.0014719 L18.9972269,13.0014719 C19.3561479,13.0014719 19.6875402,13.1938261 19.865559,13.5054887 Z M15.2315281,8.99739818 L5.99852805,3.72339818 L5.99852805,8.99739818 L15.2315281,8.99739818 Z M15.2315281,15.0014719 L5.99852805,15.0014719 L5.99852805,20.2754719 L15.2315281,15.0014719 Z",
  id: "Shape"
})));

var SvgIVerticalFlip = function SvgIVerticalFlip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIVerticalFlip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-vertical-flip.80612467.svg";
export { ForwardRef as ReactComponent };